import _ from "lodash";

import { getCommunity, getCommunityId } from "@/router/helpers/community";
import store from "@/store";

import CommunitySearch from "./CommunitySearch";
import CommunitySelect from "./CommunitySelect";
import SystemSelect from "./SystemSelect";

/**
 * "Embeddable" child paths for performing community/system selection.
 * /parent                        -> Community selection
 * /parent/:communityId           -> System selection
 * /parent/:communityId/:systemId -> Parent can now do what it needs to do
 */

const beforeEnterCommunity = async (to, from, next) => {
	if (to.query.force) {
		next();
		return;
	}

	// Skip community selection if we already have an active community:
	const id = getCommunityId(to);
	if (id) {
		let path = [...to.path.split("/"), id];
		path = "/" + _.compact(path).join("/");

		// Only redirect if it's a new location. This is an indirect way of
		// checking if the user hit the back button - in which case we want
		// to skip the redirect and always show community selection, even
		// if there's already an active community.
		if (path !== from.path) {
			next({ path });
			return;
		}
	}

	next();
};

export const communitySearch = {
	path: "",
	component: CommunitySearch,
	beforeEnter: beforeEnterCommunity,
};

export const communitySelect = {
	path: "",
	component: CommunitySelect,
	beforeEnter: beforeEnterCommunity,
};

export const systemSelect = {
	path: ":communityId",
	component: SystemSelect,
	beforeEnter: async (to, from, next) => {
		// Always make sure that systems are loaded
		try {
			const community = getCommunity(to);
			await store.dispatch("rooms/load", community);
		} catch (e) {
			return next(e);
		}

		next();
	},

	meta: {
		auth: {
			action: "read",
			subject: getCommunity,
		},
	},
};

export default {
	routes: {
		communitySearch,
		communitySelect,
		systemSelect,
	},
};
